import React from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@xsolla/ui-core';

import { StatesContent, StatesTitle, StatesWrapper } from './style';

type Props = {
  onClick?: () => void;
  'data-test-id'?: string;
};

const Fail = ({ onClick, ...props }: Props): JSX.Element => {
  const intl = useIntl();
  return (
    <StatesContent {...props}>
      <StatesWrapper>
        <StatesTitle>{intl.formatMessage({ id: 'analytics.charts.failed.title' })}</StatesTitle>
        {intl.formatMessage({ id: 'analytics.charts.failed.description' })}
      </StatesWrapper>
      {onClick && (
        <Button look="default" palette="action" onClick={onClick}>
          {intl.formatMessage({ id: 'analytics.charts.failed.refresh' })}
        </Button>
      )}
    </StatesContent>
  );
};

export default Fail;
